/**
 * Death verification API client
 * Handles death record operations
 */
import type { ApiResponse, DeathRecord, DeathInput } from './types';
import { apiClient } from './client';

/**
 * Record a verified celebrity death
 * @param poolId Pool identifier
 * @param input Death verification data
 * @returns Created death record
 */
export async function recordDeath(
  poolId: string,
  input: DeathInput
): Promise<ApiResponse<DeathRecord>> {
  return apiClient.post<DeathRecord>(`/pools/${poolId}/deaths`, input);
}

/**
 * Get all death records for a pool
 * @param poolId Pool identifier
 * @returns List of death records
 */
export async function getDeaths(
  poolId: string
): Promise<ApiResponse<DeathRecord[]>> {
  return apiClient.get<DeathRecord[]>(`/pools/${poolId}/deaths`);
}
